import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, HostListener  } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UserMgmtService } from 'src/app/_services/user-mgmt.service';
import { UserService } from 'src/app/_services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-workflow-designer',
  templateUrl: './workflow-designer.component.html',
  styleUrls: ['./workflow-designer.component.scss']
})
export class WorkflowDesignerComponent implements OnInit, AfterViewInit  {

  @ViewChild('iframeElement', { static: false }) iframe!: ElementRef;
  // @ViewChild('iframe') iframe: ElementRef;
  wfBaseUrl: string;
  iframeSrc: string = environment.workflowUIUrl;
  // iframeSrc: string = document.location.protocol + "//" + document.location.hostname  + '/workflow';
  trustedIframeSrc: SafeResourceUrl
  loadIframe: boolean;
  isAdmin: boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private userMgmtService: UserMgmtService, private cookieService: CookieService,private sanitizer: DomSanitizer) { 
    // this.wfBaseUrl = 'http://loacalhost:5200';
    this.trustedIframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeSrc);
  }
  updateIframeSource(newUrl: string) {
    this.iframeSrc = newUrl;
    this.trustedIframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeSrc);
    return this.trustedIframeSrc;
  }

  iframeHeight: string = '600px';
  workFlowId: string = '';
  userList: any = [];
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  taskName: string = '';
  instanceName: string = '';

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.adjustIframeHeight();
  }

  ngAfterViewInit(): void {

    window.addEventListener('message', (event) => {
      console.log('Parent received message iframe:', event.data);

      // ===================Navigate to workflow with parameters==========================

      const currentUser =
      this.cookieService.get("loginSubscriptionData") != ""
        ? JSON.parse(this.cookieService.get("loginSubscriptionData"))
        : undefined;
    if (currentUser) {
      if (!(currentUser.access_token)) {
        // no logged user, redirect to /login
        this.router.navigate(["/login"]);
      }
      // authorised so return true
    } else if (currentUser == undefined) {
      this.cookieService.delete("loginSubscriptionData", "/");

      this.route.queryParams.subscribe(params => {
      this.taskName = params['task'];
      this.instanceName = params['instance'];
    });

    if(this.taskName) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: "workflow/workflow-designer", row: "0", task: this.taskName },
      });
    } else if(this.instanceName) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: "workflow/workflow-designer", row: "0", instance: this.instanceName },
      });
    }
    }

      // =================================================================================

      if(event.data.text=='Hello from Iframe B!'){
        this.router.navigate(['workflow/workflow-dashboard'], {fragment : 'Templates'});
      }
      
      
      const iframeA = document.getElementById('iframeA') as HTMLIFrameElement;
      if (iframeA && iframeA.contentWindow) {
        iframeA.contentWindow.postMessage(event.data, '*');
        console.log('Message forwarded to Iframe A');
      }

    });
    const loginData = JSON.parse(this.cookieService.get('loginSubscriptionData'));
    if(!this.edit){
      this.edit='new'
    }
    let workflowObj = { currentUser: this.currentUser, workFlowId :this.workFlowId, userList : this.userList , access_token:loginData.access_token,permission:this.edit, isAdmin: this.isAdmin, parentURL: window.location.href,
                        task: this.taskName, instance: this.instanceName
    }
     console.log('permission123',workflowObj);
    
     this.iframe.nativeElement.onload = () => {

      //---------------------------------------------------

    this.userMgmtService.loadUserData().subscribe((res: any)=>{
      var masterUsers: any = [];

      if (res['masteruser'].length) {
        masterUsers = res['masteruser'];
      }
      else {
        masterUsers.push(res['masteruser']);
      }

      masterUsers?.forEach(element => {
        if(element["customer"] && element["customer"]["id"] === this.currentUser["id"]) {
          if(element["userRole"] && element["userRole"]["roleName"] == "Admin") {
            this.isAdmin = true;
            workflowObj["isAdmin"] = this.isAdmin;
          }
        }
      });

      // this.iframe.nativeElement.contentWindow.postMessage( workflowObj, 'https://dev-v5.huloop.ai:444/workflow');
      // this.loadIframe = true;
      
        let targetOrigin =  this.iframeSrc;  // Ensure the URL includes the protocol

      // Debugging: Verify the target origin
      console.log('Target Origin:', targetOrigin);

      // Log iframe's origin
      console.log('Iframe Origin:', this.iframe.nativeElement.contentWindow.location.origin);

      this.iframe.nativeElement.contentWindow.postMessage(workflowObj, targetOrigin);

    });

    //---------------------------------------------------

      
       
     
       
    };
   

    setTimeout(() => {
      this.adjustIframeHeight();
     
    }, 100);
  }
view:any;
edit:any ='new';

  ngOnInit() {

    //get the templateId
    this.route.queryParams.subscribe(params => {
      this.workFlowId = params['tempId'];
      this.view = params['view'];
      this.edit = params['edit'];
      this.taskName = params['task'];
      this.instanceName = params['instance'];
    });

    //get the updated usersList;
    this.userService.getUserList().subscribe((users: any)=>
    {
      console.log("userList : ", users);
      if(users)
      {
        this.userList = users;
      }
    })

  }
  adjustIframeHeight(): void {
    if (!this.iframe) return;
    
    const windowHeight = window.innerHeight;
    const iframeRect = this.iframe.nativeElement.getBoundingClientRect();
    const iframeTop = iframeRect.top;
    const margin = 0;
    const availableHeight = windowHeight - iframeTop - margin;
    
    this.iframeHeight = `${availableHeight}px`;
    this.iframe.nativeElement.style.height = this.iframeHeight;
    
    console.log(`Adjusted iframe height to: ${this.iframeHeight}`);
    this.iframe.nativeElement.contentWindow.postMessage({
      type: 'parent-resize',
      height: availableHeight,
    }, this.iframeSrc);
  }

}
